// ---------------------------------------------------------------------------
// matchMedia — responsive helpers. Boundary mirrors the SCSS breakpoints
// (abstracts/_breakpoints.scss): mobile/desktop split at 1024/1025px.
// ---------------------------------------------------------------------------

export const mediumUpQuery = '(min-width: 1025px)';
export const smallOnlyQuery = '(max-width: 1024px)';

export const isMediumUp = (): boolean => window.matchMedia(mediumUpQuery).matches;
export const isSmallOnly = (): boolean => window.matchMedia(smallOnlyQuery).matches;

/** Run `fn` immediately if `query` matches, otherwise once when it first does. */
export const runOnceOnQuery = (fn: () => void, query: string): void => {
	const mq = window.matchMedia(query);
	if (mq.matches) {
		fn();
		return;
	}
	const handler = (e: MediaQueryListEvent): void => {
		if (e.matches) {
			mq.removeEventListener('change', handler);
			fn();
		}
	};
	mq.addEventListener('change', handler);
};
